import * as React from "react";
import Grid from "@mui/material/Grid";
import { Autocomplete, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,TextareaAutosize, Tab, Tabs, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import WarningIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from "@mui/material/AccordionSummary";

import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { GlobalAppraisalPropertyTable } from "./GlobalAppraisalPropertyTable";
import { AppraisalReviewServiceURL, TaskmgmtServiceURL, DocumentServiceURL, LookupServieURL } from "../../../config/config";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { constants } from "buffer";
import { ServiceName } from "../../../constants";
import { useEffect, useState } from "react";
import { ViewTabList } from "../documents/ViewTabList";
import { UserContext, updateUserContext } from "../../../redux/slices/userContextSlice";
import { useAppSelector } from "../../../redux/hooks";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import axios, { AxiosError } from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Appraiser1, GlobalAppraisalFetched, GlobalAppraisalModel, GlobalAppraisalModelPost, Properties } from "../../util/All_interfaces";
import { getProfile } from "../../../services/userContext";
import { useDispatch } from "react-redux";
import { GlobalFund, updateSelectedGlobalFundAppraisal } from "../../../redux/slices/SelectedGlobalFundSlice";
import { ApplicationUser, AppraisalAttachment, AppraisalRevokedRequest, AuditLog, DocumentTypesModel, FileChunk, UploadPreSignedPayloadModel } from "../../../all_Interfaces";
import dayjs, { Dayjs } from "dayjs";
import { Controller, useForm } from "react-hook-form";
import { ToastMessage } from "../../util/ToastMessage";
import { updateAttachments } from "../../../redux/slices/UpdateExistingAttachmentSlice";
import { HorizontalStepper } from "../../util/Steper";
import { ApproveRejectComponent } from "../../util/ApproveRejectComponent";
import { addNewAttachments } from "../../../redux/slices/AddNewAttachmentsSlice";
import { addAuditLogs } from "../../../redux/slices/AuditSlice";
import AuditButton from "../Audit/auditButton";
import { wait } from "@testing-library/user-event/dist/utils";
import { GlobalHamburger } from "./GlobalHamburger";
import { nanoid } from "@reduxjs/toolkit";
import { ArgusSupportBanner } from "../../util/ArgusSupportBanner";
import { downloadGlobalProformaTemplate } from "./templates/GlobalProformaTemplate";

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&::before": {
        display: "none",
    },
}));


const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };
  
  const blue = {
    100: "#DAECFF",
    200: "#b6daff",
    400: "#3399FF",
    500: "#007FFF",
    600: "#0072E5",
    900: "#003A75",
  };
  
  const grey = {
    50: "#F3F6F9",
    100: "#E5EAF2",
    200: "#DAE2ED",
    300: "#C7D0DD",
    400: "#B0B8C4",
    500: "#9DA8B7",
    600: "#6B7A90",
    700: "#434D5B",
    800: "#303740",
    900: "#1C2025",
  };
  
  const TextareaAutosizee = styled(TextareaAutosize)(
    ({ theme }) => `
      box-sizing: border-box;
      width: 320px;
      font-family: 'IBM Plex Sans', sans-serif;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.5;
      padding: 8px 12px;
      border-radius: 8px;
      color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
      background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
      border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
      box-shadow: 0px 2px 2px ${theme.palette.mode === "dark" ? grey[900] : grey[50]
      };
    
      &:hover {
        border-color: ${blue[400]};
      }
    
      &:focus {
        border-color: ${blue[400]};
        box-shadow: 0 0 0 3px ${theme.palette.mode === "dark" ? blue[600] : blue[200]
      };
      }
    
      // firefox
      &:focus-visible {
        outline: 0;
      }
    `
  );

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, .05)"
            : "rgba(0, 0, 0, .03)",
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-content": {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

interface StyledTabProps {
    label: string;
}

const AntTabs = styled(Tabs)({
    borderBottom: '1px solid #e8e8e8',
    '& .MuiTabs-indicator': {
        backgroundColor: '#1890ff',
    },
});

const AntTab = styled((props: StyledTabProps) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        minWidth: 0,
        [theme.breakpoints.up('sm')]: {
            minWidth: 0,
        },
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(2),
        color: 'rgba(0, 0, 0, 0.85)',
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
            color: '#40a9ff',
            opacity: 1,
        },
        '&.Mui-selected': {
            color: '#1890ff',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&.Mui-focusVisible': {
            backgroundColor: '#d1eaff',
        },
    }),
);


export const GlobalAppraisalEditDisplayForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const appraisalId = params.appraisalId;
    const page = window.location.pathname.split('/')[3];
    console.log(page);
    const isSubmitEvent = React.useRef(false);
    const { control, handleSubmit } = useForm({});

    const [expanded, setExpanded] = React.useState<string | false>("panel1");
    const [loading, setLoading] = useState(false);
    const [postDataMessage, setPostDataMessage] = useState<{ code: number | undefined, message: string, isError: boolean }>({ code: 0, message: "", isError: false });
    const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
        { isError: false, message: "" }
      );
    
      const [isSuccess, setIsSuccess] = useState<{
        isSuccess: boolean;
        message: string;
      }>({ isSuccess: false, message: "" });
    const [appraisalID,setAppraisalID] = useState<string>("");
    const [scenarioId,setScenarioId] = useState<string>("");
    const [funds, setFunds] = useState<Array<{ id: number, fundID: string, fundName: string, region: string, createdBy: string }>>([]);
    const [appraiser1List, setAppraiser1List] = React.useState<Appraiser1[]>();
    const [appraiser1ListValue, setAppraiser1ListValue] = useState<any>([]);
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const [workflowSteps, setWorkflowSteps] = useState<string[]>([]);
    const [revokeComments, setRevokeComments] = useState("");
    const [attachmentErrorDialog, setAttachmentErrorDialog] = useState<{ open: boolean; message: string; btnEvent: string }>({ open: false, message: "", btnEvent: "" });
    const attachmentUploadFailed = React.useRef<boolean>(false);
    const [propertyCurrencyErrors, setPropertyCurrencyErrors] = useState<boolean[]>([]);

    const [selectedAppraiser1, setSelectedAppraiser1] = useState<Appraiser1 | null>(new Appraiser1());

    const [appraisalStatusAndScenarioID, setAppraisalStatusAndScenarioID] = useState<{ appraisalStatus: string, scenarioId: string }>();

    const NewAttachmentList: AppraisalAttachment[] = useAppSelector(
        (state) => state.AddNewAttachments.data
      );
    const [fetchedData, setFetchedData] = useState<GlobalAppraisalModelPost>(new GlobalAppraisalModelPost());

    const [fetchedDataPrior, setFetchedDataPrior] = useState<GlobalAppraisalModelPost>(new GlobalAppraisalModelPost());
    const fileSize = React.useRef<any>();
    const chunkSize = React.useRef<number>(1048576 * 3);
    const fileToBeUpload = React.useRef<any>();
    const chunkCount = React.useRef<any>();
    const chunk = React.useRef<any>();
    const fileGuid = React.useRef<any>();
    const counter = React.useRef<number>(1);
    const beginingOfTheChunk = React.useRef<number>(0);
    const endOfTheChunk = React.useRef<any>();
    const uploadStartResponse = React.useRef<any>();
    const largeFileCount = React.useRef<number>(0);

    const largeFileSuccessCount = React.useRef<number>(0);
	  const largeFileFailedCount = React.useRef<number>(0);

    const [postFormdataError, setPostFormdataError] = useState({
        fundName: false,
        appraiser1: false
    });
    const [flagtaskcomponent, setFlagtaskcomponent] = useState<boolean>(false);

    const [editFormdata, setEditFormData] = useState<GlobalAppraisalModel>();

    const [portfolioManager, setPortfolioManager] = useState({
        firstName: '',
        lastName: '',
        email: ''
    });

    const [assetManager, setAssetManager] = useState({
        firstName: '',
        lastName: '',
        email: ''
    });

    const [sectorHead, setSectorHead] = useState({
        firstName: '',
        lastName: '',
        email: ''
    });
    const [fileMessage, setFileMessage] = useState<boolean>(false);
    const [openRevokeDialog, setOpenRevokeDialog] = useState<boolean>(false);
    const [docTypesData, setDocTypesData] = useState<DocumentTypesModel[]>([]);
    const created = React.useRef("");
    const createdBy = React.useRef("");
    const [attachments, setAttachments] = useState<AppraisalAttachment[]>([]);
    const [value, setValue] = React.useState(0);
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const [isGlobalFundFieldsEditable, setIsGlobalFundFieldsEditable] = useState<boolean>(false);
    const [isGermanFund, setIsGermanFund] = useState<boolean>(false);
    
    const [disableControlesFlag,setDisableControlesFlag] = useState<boolean>(false);
    const currentUserData: CurrentUser = useAppSelector((state) => state.currentUser.data);
    const userContext: UserContext = useAppSelector((state) => state.UserContext.data);

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };


    const formatNumber = (params: any) => {
        if (params != null && params != undefined && !Number.isNaN(params) )
            return params.toLocaleString('en-US');
        else return null;
    }

    useEffect(() => {
        if (Object.keys(userContext).length == 0) {
            getProfile(true).then((data: any) => {
                dispatch(updateUserContext(data));
            });
        }
    }, []);
    useEffect(() => {
        setAttachments(NewAttachmentList);
      }, [NewAttachmentList]);

      const formatNumberTo0Decimal = (num: any) => {
        const regxmain = /^-?\d+(\.\d+)?$/;
        if (regxmain.test(num)) {
            return Number(num).toFixed(2);
          }
        return num;
      }

    const propertiesFormatting = (propertiesArray:Properties[]) => {

        const distinctProperties = propertiesArray.filter(
            (obj, index, array) =>
                array.findIndex(
                    (p) => p.propertyType === obj.propertyType
                ) === index
        );

        let distinctPropertyTypes: string[] = [];
        distinctProperties.forEach((property) =>
            distinctPropertyTypes.push(property.propertyType)
        );

        const sortedDistinctPropertyTypes = distinctPropertyTypes.sort();

        let sortedPropertiesArray: Properties[] = [];

        sortedDistinctPropertyTypes.forEach((type) => {
            let sortedPropertyArray: Properties[] = [];
            propertiesArray.forEach((property) => {
                if (property.propertyType === type) {
                    sortedPropertyArray.push(property);
                }
            });
            sortedPropertiesArray = sortedPropertiesArray.concat(
                sortedPropertyArray.sort((a, b) =>
                    a.propertyName > b.propertyName ? 1 : -1
                )
            );
        });
        return sortedPropertiesArray;
    }

    const getGlobalAppraisal = async () => {
        await getApiCall(`${AppraisalReviewServiceURL}/globalappraisals/getbyid/${appraisalId}?isloader=0`,
            ServiceName.APPRAISALREVIEW).then(async (data: any) => {
                setAppraisalStatusAndScenarioID({ appraisalStatus: data.result[0].status.toLowerCase(), scenarioId: data.result[0].scenarioId });
                setEditFormData(data.result[0]);
                created.current = data.result[0].created;
                createdBy.current = data.result[0].createdBy;
                try {
                    await getApiCall(`${AppraisalReviewServiceURL}/globalappraisals/GetIsGlobalFieldsEditableByFundId?fundid=${data.result[0].fundId}`,
                      ServiceName.APPRAISALREVIEW).then((d:any) => {
                        setIsGlobalFundFieldsEditable(d?.result && (data.result[0].status === "New" || data.result[0].status === "Revoked"  || data.result[0].status.includes("Rejected")) && page === "edit");
                        setIsGermanFund(d?.result);
                      });
                  }
                  catch (e: any) {
                    console.log("exception occurred in GetIsGlobalFieldsEditableByFundId", e);
                  }

                setPortfolioManager({
                    firstName: data.result[0].portfolioManager == null ? "" : data.result[0].portfolioManager.firstName,
                    lastName: data.result[0].portfolioManager == null ? "" : data.result[0].portfolioManager.lastName,
                    email: data.result[0].portfolioManager == null ? "" : data.result[0].portfolioManager.email
                });

                setAssetManager({
                    firstName: data.result[0].properties.assetManager == null ? "" : data.result[0].properties.assetManager.firstName,
                    lastName: data.result[0].properties.assetManager == null ? "" : data.result[0].properties.assetManager.lastName,
                    email: data.result[0].properties.assetManager == null ? "" : data.result[0].properties.assetManager.email
                });

                setSectorHead({
                    firstName: data.result[0].properties.sectorHead == null ? "" : data.result[0].properties.sectorHead.firstName,
                    lastName: data.result[0].properties.sectorHead == null ? "" : data.result[0].properties.sectorHead.lastName,
                    email: data.result[0].properties.sectorHead == null ? "" : data.result[0].properties.sectorHead.email
                });


                setActiveIndex(data.result[0].activeIndex);
                if((data.result[0].workflowsteps != undefined || data.result[0].workflowsteps != null) && data.result[0].workflowSteps != ""){
                setWorkflowSteps(JSON.parse(data.result[0].workflowsteps));
                }else{
                    setWorkflowSteps([] as string[]);
                }
                await getAppraisal1List(data.result[0].fundId,data.result[0].appraiser1);
                // var propertiesArray: Properties[] = [];
                // propertiesArray = data.result[0].properties;

                // const distinctProperties = propertiesArray.filter(
                //     (obj, index, array) =>
                //         array.findIndex(
                //             (p) => p.propertyType === obj.propertyType
                //         ) === index
                // );

                // let distinctPropertyTypes: string[] = [];
                // distinctProperties.forEach((property) =>
                //     distinctPropertyTypes.push(property.propertyType)
                // );

                // const sortedDistinctPropertyTypes = distinctPropertyTypes.sort();

                // let sortedPropertiesArray: Properties[] = [];

                // sortedDistinctPropertyTypes.forEach((type) => {
                //     let sortedPropertyArray: Properties[] = [];
                //     propertiesArray.forEach((property) => {
                //         if (property.propertyType === type) {
                //             sortedPropertyArray.push(property);
                //         }
                //     });
                //     sortedPropertiesArray = sortedPropertiesArray.concat(
                //         sortedPropertyArray.sort((a, b) =>
                //             a.propertyName > b.propertyName ? 1 : -1
                //         )
                //     );
                // });
                var sortedPropertiesArray: Properties[] = propertiesFormatting(data.result[0].properties);
                var formatedDecimalNumbersInProperty = [...sortedPropertiesArray];

                formatedDecimalNumbersInProperty.forEach((property: Properties, index: number) => {
                    formatedDecimalNumbersInProperty[index] = {
                        ...property,
                        initialYieldContracted: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].initialYieldContracted),
                        initialYieldValuation: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].initialYieldValuation),
                        reversionaryYield: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].reversionaryYield),
                        forwardInitialYield: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].forwardInitialYield),
                        trueEquivalentYield: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].trueEquivalentYield),
                        nominalEquivalentYield: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].nominalEquivalentYield),
                        growthRates: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].growthRates),
                        discountRate: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].discountRate),
                        terminalCapRate: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].terminalCapRate),
                        
                        netRentPassing: formatedDecimalNumbersInProperty[index].netRentPassing,
                        rentalValue: formatedDecimalNumbersInProperty[index].rentalValue,
                        grossValue: formatedDecimalNumbersInProperty[index].grossValue,
                        capitalExpenditure: formatedDecimalNumbersInProperty[index].capitalExpenditure,
                        acquisitionCosts: formatedDecimalNumbersInProperty[index].acquisitionCosts,
                        netValue: formatedDecimalNumbersInProperty[index].netValue,
                        sayValue: formatedDecimalNumbersInProperty[index].sayValue,
                        
                        assumedHoldingPeriod: formatedDecimalNumbersInProperty[index].assumedHoldingPeriod,
                        netExitValue: formatedDecimalNumbersInProperty[index].netExitValue,

                        propertyValueDate : formatedDecimalNumbersInProperty[index].propertyValueDate !== "" && formatedDecimalNumbersInProperty[index].propertyValueDate !== null ?
                        formatedDecimalNumbersInProperty[index].propertyValueDate.split(" ")[0] : dayjs(new Date()).format("MM-DD-YYYY"),
                    }

                });

                var dateOnly = data.result[0].valueDate?.split(" ");

                var appraiser1:ApplicationUser =  {
                    firstName: data.result[0].appraiser1 == null ? "" : data.result[0].appraiser1.firstName,
                    lastName: data.result[0].appraiser1 == null ? "" : data.result[0].appraiser1.lastName,
                    email: data.result[0].appraiser1 == null ? "" : data.result[0].appraiser1.email
                }

                var appraiser2:ApplicationUser = {
                    firstName: data.result[0].appraiser2 == null ? "" : data.result[0].appraiser2.firstName,
                    lastName: data.result[0].appraiser2 == null ? "" : data.result[0].appraiser2.lastName,
                    email: data.result[0].appraiser2 == null ? "" : data.result[0].appraiser2.email
                }
                setFetchedData({
                    ...fetchedData,
                    appraisalId: data.result[0].appraisalId,
                    fundName: data.result[0].fundName,
                    fundId: data.result[0].fundId,
                    status: data.result[0].status,
                    valueDate: dateOnly[0],
                    appraiser1: appraiser1,
                    appraiser2:appraiser2,
                    workflowId: data.result[0].workflowId,
                    workFlowSteps: data.result[0].workFlowSteps,
                    appraisalRejecetd: data.result[0].appraisalRejecetd,
                    activeIndex: data.result[0].activeIndex,
                    currency: data.result[0].currency,
                    postedAppraisalDate: data.result[0].postedAppraisalDate,
                    portfolioManager: {
                        firstName: data.result[0].portfolioManager == null ? "" : data.result[0].portfolioManager.firstName,
                        lastName: data.result[0].portfolioManager == null ? "" : data.result[0].portfolioManager.lastName,
                        email: data.result[0].portfolioManager == null ? "" : data.result[0].portfolioManager.email
                    },
                    createdBy: data.result[0].createdBy,
                    created: data.result[0].created,
                    lastModifiedBy: data.result[0].lastModifiedBy,
                    lastModified: data.result[0].lastModified,
                    scenarioId: data.result[0].scenarioId,

                    numOfTenants: formatNumber(Number(data.result[0].numOfTenants != null ? data.result[0].numOfTenants : NaN)),
                    netRentPassing: formatNumber(Number(data.result[0].netRentPassing != null ? data.result[0].netRentPassing : NaN)),
                    rentalValue: formatNumber(Number(data.result[0].rentalValue != null ? data.result[0].rentalValue : NaN)),
                    grossValue: formatNumber(Number(data.result[0].grossValue != null ? data.result[0].grossValue : NaN)),
                    capitalExpenditure: formatNumber(Number(data.result[0].capitalExpenditure != null ? data.result[0].capitalExpenditure : NaN)),
                    acquisitionCosts: formatNumber(Number(data.result[0].acquisitionCosts != null ? data.result[0].acquisitionCosts : NaN)),
                    netValue: formatNumber(Number(data.result[0].netValue != null ? data.result[0].netValue : NaN)),
                    sayValue: formatNumber(Number(data.result[0].sayValue != null ? data.result[0].sayValue : NaN)),

                    initialYieldValuation: data.result[0].initialYieldValuation,
                    initialYieldContracted: data.result[0].initialYieldContracted,
                    nominalEquivalentYield: data.result[0].nominalEquivalentYield,
                    trueEquivalentYield: data.result[0].trueEquivalentYield,
                    reversionaryYield: data.result[0].reversionaryYield,
                    displayProformaFields:data.result[0].displayProformaFields,
                    properties: formatedDecimalNumbersInProperty
                });

                const appraisalStatus:string = data.result[0].status;
                if(page === "view")
                {
                    setDisableControlesFlag(true);
                }
                else
                {
                if(!(appraisalStatus.toLowerCase() === "new" || appraisalStatus.toLowerCase().indexOf('reject') > -1 || appraisalStatus.toLowerCase() === "revoked")){
                    setDisableControlesFlag(true);
                }
                if (!(userContext.isAppraisal1 || userContext.isAdmin)) {
                    setDisableControlesFlag(true);
                  }
                }
                dispatch(updateSelectedGlobalFundAppraisal({ region: "EMEA", fundId: data.result[0].fundId, fundName: data.result[0].fundName }));


                if (data.result.length > 1) {
                    var sortedPriorPropertiesArray: Properties[] = propertiesFormatting(data.result[1].properties);
                    var formatedDecimalNumbersInPriorProperty = [...sortedPriorPropertiesArray];
                    

                    formatedDecimalNumbersInProperty.forEach((property: Properties, index: number) => {
                        formatedDecimalNumbersInProperty[index] = {
                            ...property,
                            initialYieldContracted: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].initialYieldContracted),
                            initialYieldValuation: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].initialYieldValuation),
                            reversionaryYield: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].reversionaryYield),
                            forwardInitialYield: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].forwardInitialYield),
                            trueEquivalentYield: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].trueEquivalentYield),
                            nominalEquivalentYield: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].nominalEquivalentYield),
                            growthRates: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].growthRates),
                            discountRate: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].discountRate),
                            terminalCapRate: formatNumberTo0Decimal(formatedDecimalNumbersInProperty[index].terminalCapRate),
                            
                            netRentPassing: formatNumber(Number(formatedDecimalNumbersInProperty[index].netRentPassing != null ? formatedDecimalNumbersInProperty[index].netRentPassing : NaN)),
                            rentalValue: formatNumber(Number(formatedDecimalNumbersInProperty[index].rentalValue != null ? formatedDecimalNumbersInProperty[index].rentalValue : NaN)),
                            grossValue: formatNumber(Number(formatedDecimalNumbersInProperty[index].grossValue != null ? formatedDecimalNumbersInProperty[index].grossValue : NaN)),
                            capitalExpenditure: formatNumber(Number(formatedDecimalNumbersInProperty[index].capitalExpenditure != null ? formatedDecimalNumbersInProperty[index].capitalExpenditure : NaN)),
                            acquisitionCosts: formatNumber(Number(formatedDecimalNumbersInProperty[index].acquisitionCosts != null ? formatedDecimalNumbersInProperty[index].acquisitionCosts : NaN)),
                            netValue: formatNumber(Number(formatedDecimalNumbersInProperty[index].netValue != null ? formatedDecimalNumbersInProperty[index].netValue : NaN)),
                            sayValue: formatNumber(Number(formatedDecimalNumbersInProperty[index].sayValue != null ? formatedDecimalNumbersInProperty[index].sayValue : NaN)),
                            
                            assumedHoldingPeriod: formatNumber(Number(formatedDecimalNumbersInProperty[index].assumedHoldingPeriod != null ? formatedDecimalNumbersInProperty[index].assumedHoldingPeriod : NaN)),
                            netExitValue: formatNumber(Number(formatedDecimalNumbersInProperty[index].netExitValue != null ? formatedDecimalNumbersInProperty[index].netExitValue : NaN))
                        }

                    });
                    setFetchedDataPrior({
                        ...fetchedDataPrior,
                        appraisalId: data.result[1].appraisalId,
                        fundName: data.result[1].fundName,
                        fundId: data.result[1].fundId,
                        status: data.result[1].status,
                        valueDate: data.result[1].valueDate,
                        appraiser1: {
                            firstName: data.result[1].appraiser1 == null ? "" : data.result[1].appraiser1.firstName,
                            lastName: data.result[1].appraiser1 == null ? "" : data.result[1].appraiser1.lastName,
                            email: data.result[1].appraiser1 == null ? "" : data.result[1].appraiser1.email
                        },
                        appraiser2: {
                            firstName: data.result[1].appraiser2 == null ? "" : data.result[1].appraiser2.firstName,
                            lastName: data.result[1].appraiser2 == null ? "" : data.result[1].appraiser2.lastName,
                            email: data.result[1].appraiser2 == null ? "" : data.result[1].appraiser2.email
                        },
                        workflowId: data.result[1].workflowId,
                        workFlowSteps: data.result[1].workFlowSteps,
                        appraisalRejecetd: data.result[1].appraisalRejecetd,
                        activeIndex: data.result[1].activeIndex,
                        currency: data.result[1].currency,
                        postedAppraisalDate: data.result[1].postedAppraisalDate,
                        portfolioManager: {
                            firstName: data.result[1].portfolioManager == null ? "" : data.result[1].portfolioManager.firstName,
                            lastName: data.result[1].portfolioManager == null ? "" : data.result[1].portfolioManager.lastName,
                            email: data.result[1].portfolioManager == null ? "" : data.result[1].portfolioManager.email
                        },
                        createdBy: data.result[1].createdBy,
                        created: data.result[1].created,
                        lastModifiedBy: data.result[1].lastModifiedBy,
                        lastModified: data.result[1].lastModified,
                        scenarioId: data.result[1].scenarioId,

                        numOfTenants: formatNumber(Number(data.result[1].numOfTenants != null ? data.result[1].numOfTenants : NaN)),
                        netRentPassing: formatNumber(Number(data.result[1].netRentPassing != null ? data.result[1].netRentPassing : NaN)),
                        rentalValue: formatNumber(Number(data.result[1].rentalValue != null ? data.result[1].rentalValue : NaN)),
                        grossValue: formatNumber(Number(data.result[1].grossValue != null ? data.result[1].grossValue : NaN)),
                        capitalExpenditure: formatNumber(Number(data.result[1].capitalExpenditure != null ? data.result[1].capitalExpenditure : NaN)),
                        acquisitionCosts: formatNumber(Number(data.result[1].acquisitionCosts != null ? data.result[1].acquisitionCosts : NaN)),
                        netValue: formatNumber(Number(data.result[1].netValue != null ? data.result[1].netValue : NaN)),
                        sayValue: formatNumber(Number(data.result[1].sayValue != null ? data.result[1].sayValue : NaN)),

                        initialYieldValuation: data.result[1].initialYieldValuation,
                        initialYieldContracted: data.result[1].initialYieldContracted,
                        nominalEquivalentYield: data.result[1].nominalEquivalentYield,
                        trueEquivalentYield: data.result[1].trueEquivalentYield,
                        reversionaryYield: data.result[1].reversionaryYield,
                        displayProformaFields:data.result[1].displayProformaFields,
                        properties: formatedDecimalNumbersInPriorProperty
                    });
                }
                if (appraisalStatus.search("Pending") != -1) {
                    try {
                        await getApiCall(
                            TaskmgmtServiceURL +
                            "/audittasks/GetOpenTask?isloader=0&&appraisalId=" +
                            data.result[0].appraisalId +
                            "&workflowId=" +
                            data.result[0].workflowId +
                            "&status=" +
                            data.result[0].status,
                            ServiceName.TASKMANAGEMENTSERVICE
                        ).then((data: any) => {
                            if (data.result.id) {
                                if (CheckCurrentStatusNReturnApprover(appraisalStatus, appraiser1, appraiser2))
                                    setFlagtaskcomponent(true);
                            }
                        });
                    } catch (e: any) {
                        console.log("error in audittasks/GetOpenTask : ", e);
                    }
                }


                

            }).catch((e: AxiosError) => {
                console.log(e.message);
            }).finally(() => {
                setLoading(false);
            })
    }
    const CheckCurrentStatusNReturnApprover = (
        appraisalStatus: string,appraiser1:ApplicationUser,appraiser2:ApplicationUser
      ): boolean => {
        var val = false;
        switch (appraisalStatus.toLowerCase()) {
          case "pending appraiser 2 review": {
            val = (((userContext.isAppraisal2 || userContext.isDebtAppraisal2)
              && ((appraiser1.email != userContext.email)
                || ((appraiser2 == null) ? false : appraiser2.email != userContext.email)))
              || userContext.isAdmin) ? true : false;
            break;
          }
        }
        return val;
      }

    const getAuditLogById = async () => {
        await getApiCall(`${TaskmgmtServiceURL}/AuditTasks/GetByAppraisalId/${appraisalId}?isloader=0`,
            ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => {
                console.log(data);
            }).catch((e: AxiosError) => {
                console.log(e.message);
            }).finally(() => {
                // setLoading(false);
            });
    }

    const fetchData = async () => {
        setLoading(true);
        dispatch(addNewAttachments([] as AppraisalAttachment[]));
    dispatch(updateAttachments([] as AppraisalAttachment[]));
        await getApiCall(`${TaskmgmtServiceURL}/Funds/getall`,
            ServiceName.TASKMANAGEMENTSERVICE).then(async (data: any) => {
                let tempFundsArray = [];


                if (userContext.region != '') {
                    tempFundsArray = data.result;
                    if (userContext.region == 'US;EMEA') {
                        tempFundsArray = tempFundsArray.filter((value: { region: string | string[]; }) => value.region?.includes('EMEA'));
                    }
                    else if (userContext.region == 'US;APAC') {
                        tempFundsArray = tempFundsArray.filter((value: { region: string | string[]; }) => value.region?.includes('APAC'));
                    }
                    else if (userContext.region == 'US;EMEA;APAC') {
                        tempFundsArray = tempFundsArray.filter((value: { region: string | string[]; }) => value.region?.includes('APAC') || value.region?.includes('EMEA'));
                    }
                    else if (userContext.region == 'EMEA;APAC') {
                        tempFundsArray = tempFundsArray.filter((value: { region: string | string[]; }) => value.region?.includes('EMEA') || value.region?.includes('APAC'));
                    }
                    else {
                        tempFundsArray = tempFundsArray.filter((value: { region: string | any[]; }) => value.region?.includes(userContext.region));
                    }
                }
                else {
                    tempFundsArray = data.result;
                }
                setFunds(tempFundsArray);

                // var finalObjFund: FundDDL[] = [];
                // var arrFundData = [{ "fundId": userContext.fundId, "fundName": userContext.FundName }];
                // var arrFundNameResults = arrFundData[0].fundName.split(';');
                // var arrFundIdResults = arrFundData[0].fundId.split(';');

                // for (var i = 0; i < arrFundIdResults.length; i++) {
                //   let tempObjFund: FundDDL = {
                //     fundId: '',
                //     fundName: ''
                //   }
                //   tempObjFund.fundName = arrFundNameResults[i];
                //   tempObjFund.fundId = arrFundIdResults[i];
                //   finalObjFund.push(tempObjFund);
                // }

                // let arrTempFunds = [];
                // if (finalObjFund[0].fundId.includes('Any')) {
                //   tempFundsArray.forEach(function (item: any) {
                //     if (item != null) {
                //       item.fundName = item.fundID + ' : ' + item.fundName;
                //       arrTempFunds.push({ "fundId": item.fundID, "fundName": item.fundName });
                //     }
                //   });
                // } else {
                //   finalObjFund.forEach(function (item: any) {
                //     if (item != null) {
                //       item.fundName = item.fundId + ' : ' + item.fundName;
                //       arrTempFunds.push({ "fundId": item.fundId, "fundName": item.fundName });
                //     }
                //   });
                // }

                // setLoading(false);
            }).then(() => {

            }).catch((e: AxiosError) => {
                console.log(e.message);
            }).finally(() => {

                if ((userContext.isEMEA || userContext.isAPAC)) {
                    getGlobalAppraisal();
                    getAuditLogById();
                    dispatch(addNewAttachments([]));
                    // getAllDocs();
                }
                else {
                    navigate('/unauthorized');
                }

            });

        await getApiCall(`${LookupServieURL}/DocumentTypes/GetAllEMEA`,
            ServiceName.LOOKUPSERVICE).then((data: any) => {
                setDocTypesData(data.result as DocumentTypesModel[]);
            }).catch((e: any) => {
                console.log(e);
            });

            var attcahments: AppraisalAttachment[] = [];

        await  getApiCall(
                DocumentServiceURL + "/Documents/GetGlobalAll/" + appraisalId,
                ServiceName.DOCUMENTSERVICE
              ).then ((data:any) => {
                attcahments = [...data as AppraisalAttachment[]];
              });

        await getApiCall(
            TaskmgmtServiceURL + "/AuditTasks/GetByGlobalAppraisalId/" + appraisalId,
            ServiceName.TASKMANAGEMENTSERVICE
        ).then((data: any) => {
            const loggs: AuditLog[] = [...data?.result];
            var formattedloggs: AuditLog[] = [];
            if (loggs.length != 0) {
                loggs.forEach((data: AuditLog) => {
                    const date = new Date(data.created);
                    const log: AuditLog = { ...data, created: date.toLocaleString() };
                    formattedloggs.push(log);
                });
                
            }
            const startingLog: AuditLog = {
                id: "",
                appraisalId: "",
                status: "New",
                taskComments: "",
                approverName: "Created by " + createdBy.current,
                taskStatus: "",
                previousStatus: "",
                approverEmail: "",
                workflowId: "",
                xmin: 0,
                createdBy: "",
                created: created.current,
                lastModifiedBy: "",
                lastModified: ""
            }
            formattedloggs.push(startingLog)

            dispatch(addAuditLogs(formattedloggs));
        });
        var formattedAttachments: AppraisalAttachment[] = [];
        if (attcahments.length != 0) {
            attcahments.forEach((data: AppraisalAttachment) => {
                const date = new Date(data.lastModifiedDate);
                const doc: AppraisalAttachment = {
                    ...data,
                    lastModifiedDate: date.toLocaleString(),
                };
                formattedAttachments.push(doc);
            });
        }
        if(formattedAttachments.length != 0){
            dispatch(updateAttachments(formattedAttachments as AppraisalAttachment[]));
        }
    }

    useEffect(() => {
        setLoading(true);
        if (Object.keys(userContext).length != 0) {
            fetchData();
        }
    }, [userContext]);



    const handleEffectiveDateOfValue = (d: Dayjs | null) => {
        if (d != null) {
            setFetchedData({ ...fetchedData, valueDate: d.format("MM-DD-YYYY") });
        }
    };
    const getAppraisal1List = async (fundID: any,appraiser1:ApplicationUser) => {
        await getApiCall(`${TaskmgmtServiceURL}/userrolemaps/GetAppraisal1ListByFundId?isloader=0&fundId=${fundID}`,
            ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => {

                let tempArray: Appraiser1[] = [{
                    firstName: '',
                    lastName: '',
                    name: '',
                    email: '',
                    userType: ''
                }];

                let tempValueArray: string[] = [];

                data.result?.forEach((element: any) => {
                    if (element.fundId.includes(fundID)) {
                        tempArray.push({
                            firstName: element.firstName,
                            lastName: element.lastName,
                            email: element.email,
                            name: element.firstName + " " + element.lastName,
                            userType: element.userType
                        });

                        tempValueArray.push(element.firstName + " " + element.lastName);
                    }
                });
                tempArray.shift();

                tempArray = tempArray.sort((a, b) => {
                    if (a.firstName === b.firstName) {
                        return a.lastName.localeCompare(b.lastName)
                    }
                    return a.firstName.localeCompare(b.firstName)
                }).slice();

                var a = tempArray.find((ele: Appraiser1) => ele.email.toLowerCase() == appraiser1.email.toLowerCase());
                var apprsr1 = a != undefined ? a : new Appraiser1();
                setSelectedAppraiser1(apprsr1);

                setAppraiser1List(tempArray);
                setAppraiser1ListValue(tempValueArray);
            });
    }

    const handleAppraiser1Change = (value: any) => {
        if (value != null && appraiser1List != undefined) {
            var abc = appraiser1List;
            var cbc = abc.filter(elm => elm.email == value.email);

            setFetchedData({
                ...fetchedData,
                appraiser1: { firstName: cbc[0].firstName, lastName: cbc[0].lastName, email: cbc[0].email }
            });
            setSelectedAppraiser1( {
                firstName: cbc[0].firstName, lastName: cbc[0].lastName, email: cbc[0].email,
                name: "",userType:""
            });

            setPostFormdataError({ ...postFormdataError, appraiser1: false });
        } else {
            setSelectedAppraiser1(null);
            setFetchedData({ ...fetchedData, appraiser1: { firstName: '', lastName: '', email: '' } });
            setPostFormdataError({ ...postFormdataError, appraiser1: true });
        }
    }

    const resetChunkProperties = () => {
        //setShowProgress(true);
        //setProgress(0);
        setCounter(1);
        beginingOfTheChunk.current = 0;
        endOfTheChunk.current = chunkSize.current;
      }
    
      const setCounter = (counterr: number) => {
        counter.current = counterr;
      }


    const submitAttachment = async (data:any,btnEvent:string) => {

        let observableBatch: { promise: Promise<any>; doctype: string }[] = [];
        var tempAttachments = [...attachments];
    
    
            for (let i = 0; i < tempAttachments.length; i++) {
          setFileMessage(true);
          var tempFilePayload = new UploadPreSignedPayloadModel();
          tempFilePayload.doctype = tempAttachments[i].doctype;
          tempFilePayload.fileAsBase64 = tempAttachments[i].fileAsBase64;
          tempFilePayload.fileName = tempAttachments[i].fileName;
          tempFilePayload.fileSize = tempAttachments[i].fileSize;
          tempFilePayload.fileType = tempAttachments[i].fileType;
          tempFilePayload.guid = data.appraisalId;
          tempFilePayload.lastModifiedBy = tempAttachments[i].lastModifiedBy;
          tempFilePayload.lastModifiedDate = tempAttachments[i].lastModifiedDate;
          tempFilePayload.lastModifiedTime = tempAttachments[i].lastModifiedTime;
          tempFilePayload.scenarioId = data.scenarioId;
    
    
                if (tempFilePayload.fileSize < 26000000) {
                    observableBatch.push({
                        promise: postApiCall(DocumentServiceURL + "/Documents/add",tempFilePayload,ServiceName.DOCUMENTSERVICE),
                        doctype: tempFilePayload.doctype
                    });
                }
                else {
    
                    largeFileCount.current++;
                    await startFileChunkUpload(tempFilePayload);
                }
            }
    
            const results = await Promise.allSettled(observableBatch.map(item => item.promise));
            const failedUploads = results
                .map((result, index) => ({ result, doctype: observableBatch[index].doctype }))
                .filter(item => item.result.status === 'rejected');

            if (failedUploads.length > 0) {
                const proformaFailed = failedUploads.some(
                    item => item.doctype?.toLowerCase() === "nvh valuation proforma"
                );
                if (proformaFailed) {
                    throw { isProformaError: true, message: "The proforma format is incorrect. Please update the proforma as per the template here and upload the file again." };
                } else {
                    throw { isProformaError: false, message: "One or more document uploads failed. Please try again." };
                }
            }

            console.log("Direct upload document was saved Successfully");
            await waitForLargeFileToBeUploaded(btnEvent);

      };

      const startFileChunkUpload = async (file:any) => {

		fileSize.current = file.fileSize;

		const _totalCount = fileSize.current % chunkSize.current == 0 ? fileSize.current / chunkSize.current : Math.floor(fileSize.current / chunkSize.current) + 1; // Total count of chunks will have been upload to finish the file
		chunkCount.current = _totalCount;

		//let tmpDirectoryName = {tmpDirectoryName:file.guid};
		let chunkFile = new FileChunk();
		chunkFile.fileAsBase64 = "";

		chunkFile.tmpDirectory = file.guid;
		chunkFile.fileName = file.fileName;

		return await postApiCall(DocumentServiceURL + "/Documents/start",chunkFile,ServiceName.DOCUMENTSERVICE).then(async (data: any) => {
				console.log('success', data);
				uploadStartResponse.current = data;
				await fileUpload(file, uploadStartResponse.current);

				return uploadStartResponse.current;
			}
		).catch((e:any)=> {
      console.log("Chunk Upload error ",e);
      
    }).then((d:any)=>{
      console.log("Complete");
    });
	}

  const fileUpload = async (file, uploadStartResponse) => {
		endOfTheChunk.current = chunkSize.current ;
		while (beginingOfTheChunk.current  <= file.fileAsBase64.length) {

			var chunk = file.fileAsBase64.slice(beginingOfTheChunk.current , endOfTheChunk.current );


			let chunkFile = new FileChunk();
			chunkFile.fileAsBase64 = chunk;

			chunkFile.tmpDirectory = uploadStartResponse.tmpDirectoryName;
			chunkFile.fileName = file.fileName;
			chunkFile.fileSize = file.size;
			chunkFile.lastModifiedTime = file.lastModifiedTime;
			chunkFile.lastModifiedDate = file.lastModifiedDate;
			chunkFile['estUploadDate'] = file.estUploadDate;
			chunkFile.lastModifiedBy = file.lastModifiedBy;
			chunkFile.fileIndex = counter.current;

			let responseData = await uploadChunk(chunkFile);

			setCounter(counter.current  + 1);
			beginingOfTheChunk.current  = endOfTheChunk.current ;
			endOfTheChunk.current  = endOfTheChunk.current  + chunkSize.current ;

		}
		uploadCompleted(uploadStartResponse, file);

	}

  const uploadChunk = async (chunkFile: any): Promise<any> => {
		try {

			return await postApiCall(DocumentServiceURL + "/Documents/chunk",chunkFile,ServiceName.DOCUMENTSERVICE).then(
				(data:any) => {
					console.log('success', data);
					return true;
				},
				(error:any) => {
					console.error('error', error);
					return false;

				}
			);


		} catch (error) {

			console.log('error', error)
		}
	}


  const uploadCompleted = async (uploadStartResponse, file)  => {
		let chunkFile = new FileChunk();
		chunkFile.fileAsBase64 = "";

		chunkFile.tmpDirectory = uploadStartResponse.tmpDirectoryName;
		chunkFile.fileName = file.fileName;
		chunkFile.guid = file.guid;
		chunkFile.doctype = file.doctype;
		chunkFile.fileSize = file.fileSize;

		chunkFile.lastModifiedTime = file.lastModifiedTime;
		chunkFile.lastModifiedDate = file.lastModifiedDate;
		chunkFile.lastModifiedBy = file.lastModifiedBy;


		return await postApiCall(DocumentServiceURL + "/Documents/end",chunkFile,ServiceName.DOCUMENTSERVICE).then( (data: any) => {
				console.log('success', data);
				let uploadEndResponse = data;
				largeFileSuccessCount.current++;
				return data;

			}
      // ,
			// error: (error: any) => {
			// 	console.error('error', error);
			// 	this.largeFileFailedCount++;
			// 	return error;

			// }
		).catch((e:any)=> {
      console.log("Chunk Upload error ",e);
      
    }).then((d:any)=>{
      console.log("Complete");
    });
	}


  const waitForLargeFileToBeUploaded = async (btnEvent) => {
		while (largeFileCount.current != largeFileSuccessCount.current + largeFileFailedCount.current) {
			await wait(2000);
		}
		setIsSuccess({ isSuccess: true, message: `Appraisal has been ${btnEvent == 'submit' ? 'submitted' : 'saved'}` });
    wait(5000).then(() => {
          setFileMessage(false);
              setIsSuccess({ isSuccess: false, message: '' });
              setIsError({ isError: false, message: '' });
              window.location.reload();
            }); 
	}

    const hasAnyNumericValue = (property: Properties): boolean => {
        const numericFields = [
            property.rentalValue, property.netRentPassing, property.grossValue,
            property.capitalExpenditure, property.acquisitionCosts, property.netValue,
            property.sayValue, property.initialYieldValuation, property.initialYieldContracted,
            property.nominalEquivalentYield, property.trueEquivalentYield, property.reversionaryYield,
            property.terminalCapRate, property.discountRate, property.assumedHoldingPeriod,
            property.growthRates, property.netExitValue, property.forwardInitialYield,
        ];
        return numericFields.some(v => {
            if (v === null || v === undefined || v === '') return false;
            const num = Number(String(v).replace(/,/g, ''));
            return !isNaN(num) && num !== 0;
        });
    };

    const saveSubmitForm = (btnEnevt:string) => {
        if (fetchedData.fundName.length === 0 || fetchedData.appraiser1 === null || fetchedData.appraiser1 == undefined || fetchedData.appraiser1.email == "" ) {
            setIsError({message: "Please correct the validation errors!", isError: true });
            setTimeout(() => { setIsError({ message: "", isError: false }); }, 3000);
            return;
        }

        const currencyErrors = (fetchedData.properties || []).map(
            (p) => hasAnyNumericValue(p) && (!p.currency || p.currency.trim() === '')
        );
        setPropertyCurrencyErrors(currencyErrors);
        const hasCurrencyError = currencyErrors.some(Boolean);

        const errorMessages: string[] = [];

        if (hasCurrencyError) {
            errorMessages.push("Currency is required for properties with numeric values!");
        }

        if ((fetchedData.netValue == null || fetchedData.netValue == "") && btnEnevt === "Submit") {
            errorMessages.push("Net Value field cannot be blank!");
        }

        if (btnEnevt === "Submit" && !(fetchedData.properties || []).some((p) => hasAnyNumericValue(p))) {
            errorMessages.push("At least one property detail is needed to submit the form!");
        }

        if (errorMessages.length > 0) {
            setIsError({ message: errorMessages.join(" | "), isError: true });
            setTimeout(() => { setIsError({ message: "", isError: false }); }, 3000);
            return;
        }

        setIsError({ message: "", isError: false });
        addDataToDB(btnEnevt);
        console.log(fetchedData);
    }

    const convertToSimpleNumber = (input:any) : number | null => {
        console.log(typeof(input));
        console.log(input);
        if (input != null) {
            const sanitizedString = input?.toString().replace(/,/g, '');
            const numberValue = Number(sanitizedString);
            return isNaN(numberValue) ? null : numberValue;
        }
        return null;
      }
    

    const addDataToDB = async (btnEvent: string) => {
        setLoading(true);
        var propertiesPayloadTemp: Properties[] = [...fetchedData.properties];
        var propertiesPayload: Properties[] = [];
        propertiesPayloadTemp.forEach((property: Properties, index: number) => {
            propertiesPayload.push({
                ...property,
                netRentPassing: convertToSimpleNumber(property.netRentPassing),
                rentalValue: convertToSimpleNumber(property.rentalValue),
                grossValue: convertToSimpleNumber(property.grossValue),
                capitalExpenditure: convertToSimpleNumber(property.capitalExpenditure),
                acquisitionCosts: convertToSimpleNumber(property.acquisitionCosts),
                netValue: convertToSimpleNumber(property.netValue),
                sayValue: convertToSimpleNumber(property.sayValue),
                assumedHoldingPeriod: convertToSimpleNumber(property.assumedHoldingPeriod),
                netExitValue: convertToSimpleNumber(property.netExitValue),
                terminalCapRate: convertToSimpleNumber(property.terminalCapRate) ?? 0,
                discountRate: convertToSimpleNumber(property.discountRate) ?? 0,
                propertyValueDate: isGlobalFundFieldsEditable ? property.propertyValueDate : fetchedData.valueDate,
            })
        });
        const payload: GlobalAppraisalModelPost = {
            ...fetchedData,
            numOfTenants: convertToSimpleNumber(fetchedData.numOfTenants),
            sayValue: convertToSimpleNumber(fetchedData.sayValue),
            netValue: convertToSimpleNumber(fetchedData.netValue),
            netRentPassing: convertToSimpleNumber(fetchedData.netRentPassing),
            acquisitionCosts: convertToSimpleNumber(fetchedData.acquisitionCosts),
            capitalExpenditure: convertToSimpleNumber(fetchedData.capitalExpenditure),
            grossValue: convertToSimpleNumber(fetchedData.grossValue),
            rentalValue: convertToSimpleNumber(fetchedData.rentalValue),
            properties:propertiesPayload
        }
        if (btnEvent == "Save") {
            payload.status = "New";
          }
          else {
            if (btnEvent == "Submit")
                payload.status = "Submit";
          }
        await postApiCall(`${AppraisalReviewServiceURL}/globalappraisals/${btnEvent}`, payload,
            ServiceName.APPRAISALREVIEW).then(async (data: any) => {
                if (btnEvent == "Save") {
                    setAppraisalID(data.result.value.appraisalId);
                    setScenarioId(data.result.value.scenarioId);
                    try {
                        await submitAttachment(data.result.value, "save");
                        setFileMessage(false);
                        setIsSuccess({ message: `Appraisal has been saved`, isSuccess: true });
                        window.location.reload();
                    } catch (attachErr: any) {
                        attachmentUploadFailed.current = true;
                        setLoading(false);
                        setFileMessage(false);
                        if (attachErr?.isProformaError) {
                            const errMsg = "The proforma format is incorrect. Please update the proforma as per the template here and upload the file again.";
                            setAttachmentErrorDialog({ open: true, message: errMsg, btnEvent });
                        } else {
                            setIsError({ message: attachErr?.message || "Document upload failed. Please try again.", isError: true });
                        }
                        return;
                    }
                }
                if (btnEvent == "Submit") {
                    try {
                        await submitAttachment(data.result, "submit");
                        setFileMessage(false);
                        setScenarioId(data.result.scenarioId);
                        setIsSuccess({ message: `Appraisal has been submitted`, isSuccess: true });
                    } catch (attachErr: any) {
                        attachmentUploadFailed.current = true;
                        setLoading(false);
                        setFileMessage(false);
                        if (attachErr?.isProformaError) {
                            const errMsg = "The proforma format is incorrect. Please update the proforma as per the template here and upload the file again.";
                            setAttachmentErrorDialog({ open: true, message: errMsg, btnEvent });
                        } else {
                            setIsError({ message: attachErr?.message || "Document upload failed. Please try again.", isError: true });
                        }
                        return;
                    }
                }

                console.log(data);
                wait(3000).then(() => {
                if (btnEvent == "Save"){
                   window.location.reload();
                }});
                setLoading(false);
            }).catch((e: AxiosError) => {
                setLoading(false);

                    setIsError({  message: `Appraisal could not be saved ${btnEvent === 'Save'? 'saved' : 'submitted'}`, isError: true });
                
            }).finally(() => {
               
                wait(3000).then(() => {
                    isSubmitEvent.current = false;
                    setIsError({  message: "", isError: false });
                    setIsSuccess({ message: "", isSuccess: false });
                    if (btnEvent !== "Save" && !attachmentUploadFailed.current){
                        navigate('/global/dashboard');
                    }
                    attachmentUploadFailed.current = false;
                });
                
            })
    }
    


    const getExistingPendingAppraisals = async (fundID: any) => {
        var flag: boolean = false;
        await getApiCall(`${AppraisalReviewServiceURL}/globalappraisals/GetPendingGlobalAppraisalByFundId?fundId=${fundID}`,
            ServiceName.APPRAISALREVIEW).then((data: any) => {
                var pendingCount = data.result.appraisalId;
                if (pendingCount) {
                    flag = true;
                }
            }).catch((e: AxiosError) => {
                setLoading(false);
            });
            return flag;
    }

        const revokeappraisal = async () => {
            if (revokeComments != "") {
              var revokeRequest = new AppraisalRevokedRequest();
        
              revokeRequest.Id = fetchedData.appraisalId;
              revokeRequest.UerEmail = userContext.email;
              revokeRequest.Comments = revokeComments;
              var flag = await getExistingPendingAppraisals(fetchedData.fundId)
              if (!flag) {
                try {
                  postApiCall(
                    AppraisalReviewServiceURL + "/globalappraisals/RevokeGlobalAppraisal",
                    revokeRequest,
                    ServiceName.APPRAISALREVIEW
                  )
                    .then((data: any) => {
                      if (data.message === "POST Request successful.") {
                        setIsSuccess({
                          isSuccess: true,
                          message: "Appraisal has been Revoked",
                        });
                        wait(3000).then(() => {
                          setIsSuccess({ isSuccess: false, message: "" });
                          navigate("/global/dashboard");
                        });
                      }
                    })
                    .catch((e: any) => {
                      setIsError({
                        isError: true,
                        message: "Appraisal could not be revoked",
                      });
                      wait(3000).then(() => {
                        setIsError({ isError: false, message: "" });
                      });
                    });
                } catch (e) {
                  console.log(e);
                }
              } else {
                handleClose();
                setIsError({ isError: true, message: "Could Not be revoked as there are some pending appraisal for this fund." });
              }
            } else {
              setIsError({
                isError: true,
                message: "Please Add the comments for Appraisal to be Revoked",
              });
              wait(3000).then(() => {
                setIsError({ isError: false, message: "" });
              });
            }
          };

    const handleClose = () => {
        setOpenRevokeDialog(false);
    };

    // const deleteAppraisal = () => {
    //     if (fetchedData.status.toLowerCase() != "posted") {
    //         //addDataToDB("delete");
    //     }
    // };

    const formatNumberWithCommas = (num: number | string | null) => {
        if(num != null)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',').replace(/(?<=\.\d*?),/g,'');
        return "";
      }

      const handlePropertyValuedate = (d: Dayjs | null,i:any) => {
        if (d != null) {
            var tempRows = [...fetchedData.properties];
            tempRows[i] = { ...tempRows[i], propertyValueDate: d.format("MM-DD-YYYY") };
            setFetchedData({...fetchedData,properties:tempRows})
        }
      }

      //Properties level onchanges functions
      const handleRentalValue = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], rentalValue: formatedValue };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleNetrentpassing = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], netRentPassing: formatedValue };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleGrossvalue = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], grossValue: formatedValue };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleCapitalexpenditure = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], capitalExpenditure: formatedValue };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleAcquisitioncosts = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], acquisitionCosts: formatedValue };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleNetvalue = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], netValue: formatedValue };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleSayvalue = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], sayValue: formatedValue };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleInitialyieldvaluation = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], initialYieldValuation: plainNumber };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleInitialyieldcontracted = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], initialYieldContracted: plainNumber };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleNominalequivalentyield = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], nominalEquivalentYield: plainNumber };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleTrueequivalentyield = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], trueEquivalentYield: plainNumber };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleReversionaryyield = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], reversionaryYield: plainNumber };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleAssumedholdingperiod = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], assumedHoldingPeriod: formatedValue };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleDiscountrate = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], discountRate: plainNumber };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleForwardinitialyield = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], forwardInitialYield: plainNumber };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleGrowthrates = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], growthRates: plainNumber };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleNetexitvalue = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], netExitValue: formatedValue };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }
      const handleTerminalCapRate = (value: any, i: any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);    
          var tempRows = [...fetchedData.properties];
          tempRows[i] = { ...tempRows[i], terminalCapRate: plainNumber };
          setFetchedData({...fetchedData,properties:tempRows})
        }
      }

      const handleCurrency = (value: any, i: any) => {
        var tempRows = [...fetchedData.properties];
        tempRows[i] = { ...tempRows[i], currency: value };
        setFetchedData({...fetchedData, properties: tempRows});
      }
      

      //Fund Level onchange functions
      const handleFundNoOfTenants = (value:any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);
          setFetchedData({ ...fetchedData, numOfTenants:formatedValue });
        }
      }
      const handleFundSayValue = (value:any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);
          setFetchedData({ ...fetchedData, sayValue:formatedValue });
        }
      }  
      const handleFundNetValue = (value:any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);
          setFetchedData({ ...fetchedData, netValue:formatedValue });
        }
      }  
      const handleFundNetRentPassing = (value:any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);
          setFetchedData({ ...fetchedData, netRentPassing:formatedValue });
        }
      }
      const handleFundAcquisitionCost = (value:any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);
          setFetchedData({ ...fetchedData, acquisitionCosts:formatedValue });
        }
      }  
      const handleFundCapitalExpenditure = (value:any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);
          setFetchedData({ ...fetchedData, capitalExpenditure:formatedValue });
        }
      }  
      const handleFundGrossValue = (value:any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);
          setFetchedData({ ...fetchedData, grossValue:formatedValue });
        }
      }  
      const handleFundRentalValue = (value:any) => {
        const plainNumber = value.replace(/,/g, '');
        if (!isNaN(Number(plainNumber))) {
          var formatedValue = formatNumberWithCommas(plainNumber);
          setFetchedData({ ...fetchedData, rentalValue:formatedValue });
        }
      }  

    return (
        <div className="form-wrap">
            <ArgusSupportBanner />
            <Dialog
                open={attachmentErrorDialog.open}
                onClose={() => {
                    setAttachmentErrorDialog({ open: false, message: "", btnEvent: "" });
                }}
                PaperProps={{
                    sx: {
                        borderRadius: "12px",
                        minWidth: "450px",
                        maxWidth: "500px",
                        position: "relative",
                        padding: "40px 32px 32px",
                    },
                }}
            >
                <IconButton
                    size="small"
                    onClick={() => {
                        setAttachmentErrorDialog({ open: false, message: "", btnEvent: "" });
                    }}
                    sx={{ position: "absolute", top: 8, right: 8, color: "#9e9e9e" }}
                    aria-label="close"
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                    <WarningIcon sx={{ fontSize: 52, color: "#f44336", mb: 2 }} />
                    <Typography sx={{ fontWeight: 600, fontSize: "1.15rem", color: "#212121", mb: 1.5 }}>
                        We are saving your appraisal, but the proforma is incorrect
                    </Typography>
                    <Typography sx={{ fontSize: "0.875rem", color: "#757575", lineHeight: 1.8 }}>
                        Please update the proforma as per the template  
                    </Typography>
                    <Typography sx={{ fontSize: "0.875rem", color: "#757575" }}>
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                downloadGlobalProformaTemplate();
                                setAttachmentErrorDialog({ open: false, message: "", btnEvent: "" });
                            }}
                            style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                        >
                            here
                        </a>
                        {" "}before submitting the appraisal.
                    </Typography>
                </Box>
            </Dialog>
            {isError.isError && (
        <ToastMessage message={isError.message} severity="error" />
      )}
      {isSuccess.isSuccess && (
        <ToastMessage message={isSuccess.message} severity="success" />
      )}
            {postDataMessage.isError ?
                <ToastMessage message={postDataMessage.message} severity="error" />
                : null}
            {postDataMessage.code == 200 ?
                <ToastMessage message={postDataMessage.message} severity="success" />
                : null}
            {loading ? (
                <div className="overlaySpinner">
                    <CircularProgress />
                </div>
            ) : null}
            {fileMessage && (
            <div className="overlaySpinner">
              { fileMessage  && <><span>File upload is in progress... &nbsp;  </span>
              <CircularProgress /></> }
            </div>
          )}
            {isError.isError && (
                <ToastMessage message={isError.message} severity="error" />
            )}
            {isSuccess.isSuccess && (
                <ToastMessage message={isSuccess.message} severity="success" />
            )}

            <Dialog open={openRevokeDialog} onClose={handleClose}>
                <DialogTitle>Enter Comments *</DialogTitle>
                <DialogContent>
                    <TextareaAutosizee
                        required
                        value={revokeComments}
                        autoFocus
                        id="comment"
                        aria-label="empty textarea"
                        placeholder="Enter Comments Here..."
                        minRows={7}
                        onChange={(e: any) => setRevokeComments(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: "none" }} onClick={revokeappraisal} color="primary">
                        Confirm
                    </Button>
                    <Button sx={{ textTransform: "none" }} onClick={handleClose} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Box sx={{ width: "100%", typography: "body1" }}>
                <Grid container spacing={3}>
                    <Grid item xs>
                    </Grid>
                    <Grid item xs={6}>
                        <HorizontalStepper workflowSteps={workflowSteps} activeIndex={activeIndex} />
                    </Grid>
                    <Grid item xs>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6} sm={6}></Grid>
                    <Grid item xs={6} sm={6} className="HamburgerActionButtons">
                        <AuditButton />
                        <GlobalHamburger 
                        appraisalId={appraisalId}
                        loading={setLoading}
                        userContext={userContext}
                        workflowId={fetchedData.workflowId}
                        // deleteAppraisal={deleteAppraisal}
                        openRevokeDialog={setOpenRevokeDialog}
                        isSuccess={setIsSuccess}
                        isError={setIsError}
                        />
                    </Grid>
                </Grid>
                <h3 className="heading">Fund Details :</h3>
                <Grid container spacing={3}>
                    <Grid item xs={6} sm={6} >
                        <TextField
                            {...params}
                            size="small"
                            label="Fund Name"
                            required
                            InputLabelProps={{
                                sx:{
                                    '& .MuiInputLabel-asterisk' : {
                                      color:'red',
                                    },
                                },
                              }}
                            inputProps={{
                                readOnly: true
                            }}
                            value={fetchedData.fundId + " : " +  fetchedData.fundName}
                            style={{ width: "100%" }}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6} >
                        <TextField
                            {...params}
                            size="small"
                            label="Portfolio Manager"
                            required
                            InputLabelProps={{
                                sx:{
                                    '& .MuiInputLabel-asterisk' : {
                                      color:'red',
                                    },
                                },
                              }}
                            inputProps={{
                                readOnly: true
                            }}
                            value={fetchedData.portfolioManager?.firstName + " " + fetchedData.portfolioManager?.lastName}
                            style={{ width: "100%" }}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    {/* <Grid item xs={6} sm={6}>
                        <Autocomplete
                            id="appraiser-1"
                            options={appraiserArray}
                            // sx={{ width: 400 }}
                            renderInput={(params) => (
                                <TextField {...params} label="Appraiser 1 " size="small"
                                    value={fetchedData.appraiser1.firstName + " " + fetchedData.appraiser1.lastName}
                                />
                            )}
                        />
                    </Grid> */}
                    <Grid item xs={6} sm={6} >
                    <Controller
                name="appraiser1"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    id="fund-id"
                    readOnly={disableControlesFlag}
                    options={appraiser1List || []}
                    getOptionLabel={(option) => {
                      return option.firstName + " " + option.lastName;
                    }}
                    value={selectedAppraiser1}
                    onChange={(event: any, value: any) => {
                      handleAppraiser1Change(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Appraiser 1"
                        size="small"
                        required
                        InputLabelProps={{
                            sx:{
                                '& .MuiInputLabel-asterisk' : {
                                  color:'red',
                                },
                            },
                          }}
                        error={postFormdataError.appraiser1}
                      />
                    )}
                  />
                )}
              />
                    </Grid>
                    <Grid item xs={6} sm={6} sx={{ marginTop: "-5px" }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer
                                components={["DatePicker", "DatePicker", "DatePicker"]}
                            >
                                <DatePicker
                                    name="startDate"
                                    sx={{ width: 300 }}
                                    readOnly={disableControlesFlag}
                                    format="MMM-DD-YYYY"
                                    slotProps={{ textField: { size: "small" } }}
                                    label="Effective Date of Value"
                                    value={fetchedData.valueDate === "" ||
                                        fetchedData.valueDate == null
                                        ? null
                                        : dayjs(
                                            fetchedData.valueDate,
                                            "MM-DD-YYYY"
                                        )}
                                    views={["month", "day", "year"]}
                                    onChange={(newValue: Dayjs | null) =>
                                        handleEffectiveDateOfValue(newValue)
                                    }
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </Grid>
                </Grid>
            </Box>
            <Divider className="divider-line"></Divider>
            <Box sx={{ bgcolor: 'background.paper' }}>
                <AntTabs value={value} onChange={handleTabChange} aria-label="ant example">
                    <AntTab label="Current Value" />
                    <AntTab label="Prior Value" />
                </AntTabs>
            </Box>

            <Box sx={{ width: "100%", typography: "body1" }}>
                <h3 className="heading">Argus Details :</h3>

                {value == 0 && <><Grid container spacing={3}>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="No. of Tenants"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: !isGlobalFundFieldsEditable
                            }}
                            onChange={(e) => handleFundNoOfTenants(e.target.value)}
                            value={fetchedData.numOfTenants !== null && fetchedData.numOfTenants !== undefined ? fetchedData.numOfTenants : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Net Rent Passing"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: !isGlobalFundFieldsEditable
                            }}
                            onChange={(e) => handleFundNetRentPassing(e.target.value)}
                            inputMode="decimal"
                            value={fetchedData.netRentPassing !== null && fetchedData.netRentPassing !== undefined ? fetchedData.netRentPassing : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Rental Value"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: !isGlobalFundFieldsEditable
                            }}
                            onChange={(e) => handleFundRentalValue(e.target.value)}
                            value={fetchedData.rentalValue !== null && fetchedData.rentalValue !== undefined ? fetchedData.rentalValue : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Gross Value"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: !isGlobalFundFieldsEditable
                            }}
                            onChange={(e) => handleFundGrossValue(e.target.value)}
                            value={fetchedData.grossValue !== null && fetchedData.grossValue !== undefined ? fetchedData.grossValue :  ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Capital Expenditure"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: !isGlobalFundFieldsEditable
                            }}
                            onChange={(e) => handleFundCapitalExpenditure(e.target.value)}
                            value={fetchedData.capitalExpenditure !== null && fetchedData.capitalExpenditure !== undefined ? fetchedData.capitalExpenditure : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Acquisition Costs "
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: !isGlobalFundFieldsEditable
                            }}
                            onChange={(e) => handleFundAcquisitionCost(e.target.value)}
                            value={fetchedData.acquisitionCosts !== null && fetchedData.acquisitionCosts !== undefined ? fetchedData.acquisitionCosts : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Net Value"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: !isGlobalFundFieldsEditable
                            }}
                            onChange={(e) => handleFundNetValue(e.target.value)}
                            error = { isSubmitEvent.current ? (fetchedData.netValue === null || fetchedData.netValue === undefined || fetchedData.netValue === "") : false}
                            value={fetchedData.netValue !== null && fetchedData.netValue !== undefined ? fetchedData.netValue : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Say Value"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: !isGlobalFundFieldsEditable
                            }}
                            onChange={(e) => handleFundSayValue(e.target.value)}
                            value={fetchedData.sayValue !== null && fetchedData.sayValue !== undefined ? fetchedData.sayValue : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                </Grid></>}
                {value == 1 && <><Grid container spacing={3}>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="No. of Tenants"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: true
                            }}
                            value={fetchedDataPrior.numOfTenants !== null && fetchedDataPrior.numOfTenants !== undefined ? fetchedDataPrior.numOfTenants : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Net Rent Passing"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: true
                            }}
                            inputMode="decimal"
                            value={fetchedDataPrior.netRentPassing !== null && fetchedDataPrior.netRentPassing !== undefined ? fetchedDataPrior.netRentPassing : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Rental Value"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: true
                            }}
                            value={fetchedDataPrior.rentalValue !== null && fetchedDataPrior.rentalValue !== undefined ? fetchedDataPrior.rentalValue : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Gross Value"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: true
                            }}
                            value={fetchedDataPrior.grossValue !== null && fetchedDataPrior.grossValue !== undefined ? fetchedDataPrior.grossValue :  ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Capital Expenditure"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: true
                            }}
                            value={fetchedDataPrior.capitalExpenditure !== null && fetchedDataPrior.capitalExpenditure !== undefined ? fetchedDataPrior.capitalExpenditure : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Acquisition Costs "
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: true
                            }}
                            value={fetchedDataPrior.acquisitionCosts !== null && fetchedDataPrior.acquisitionCosts !== undefined ? fetchedDataPrior.acquisitionCosts : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Net Value"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: true
                            }}
                            value={fetchedDataPrior.netValue !== null && fetchedDataPrior.netValue !== undefined ? fetchedDataPrior.netValue : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            label="Say Value"
                            variant="outlined"
                            size="small"
                            fullWidth
                            inputProps={{
                                readOnly: true
                            }}
                            value={fetchedDataPrior.sayValue !== null && fetchedDataPrior.sayValue !== undefined ? fetchedDataPrior.sayValue : ""}
                            className={ page === "view" ? "Autopopulatefield" : ""}
                        />
                    </Grid>
                </Grid></>}
            </Box>
            <Divider className="divider-line"></Divider>
            <Box
                sx={{ width: "100%", typography: "body1" }}
                className="accordion-wrap"
            >
                <Accordion defaultExpanded>
                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                        <Typography>Property Level Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <GlobalAppraisalPropertyTable
                            isEditable={isGlobalFundFieldsEditable}
                            isGermanFund={isGermanFund}
                            currentData={fetchedData.properties}
                            handleRentalValue={handleRentalValue}
                            handleNetrentpassing={handleNetrentpassing}
                            handleGrossvalue={handleGrossvalue}
                            handleCapitalexpenditure={handleCapitalexpenditure}
                            handleAcquisitioncosts={handleAcquisitioncosts}
                            handleNetvalue={handleNetvalue}
                            handleSayvalue={handleSayvalue}
                            handleInitialyieldvaluation={handleInitialyieldvaluation}
                            handleInitialyieldcontracted={handleInitialyieldcontracted}
                            handleNominalequivalentyield={handleNominalequivalentyield}
                            handleTrueequivalentyield={handleTrueequivalentyield}
                            handleReversionaryyield={handleReversionaryyield}
                            handleAssumedholdingperiod={handleAssumedholdingperiod}
                            handleDiscountrate={handleDiscountrate}
                            handleForwardinitialyield={handleForwardinitialyield}
                            handleGrowthrates={handleGrowthrates}
                            handleNetexitvalue={handleNetexitvalue}
                            handleTerminalCapRate={handleTerminalCapRate}
                            handlePropertyValuedate={handlePropertyValuedate}
                            handleCurrency={handleCurrency}
                            currencyErrors={propertyCurrencyErrors}
                            isViewForm = {page === "view"}
                            priorData={fetchedDataPrior.properties || []}
                            editDisplay={true}
                            displayProformaFields={fetchedData.displayProformaFields}
                            />
                    </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                    <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                        <Typography>Documents</Typography>
                    </AccordionSummary>
                    <AccordionDetails className="upload-document">
                        {docTypesData.length != 0 && (
                            <ViewTabList tabData={docTypesData} />
                        )}
                    </AccordionDetails>
                </Accordion>
            </Box>
            <Box sx={{ padding: "15px 2px" }}>
                {page !== "view" && <Button sx={{textTransform:"none"}} disabled={disableControlesFlag} variant="contained" size="medium" color="success" onClick={() => {
                    saveSubmitForm("Save");
                    setPostFormdataError({
                        ...postFormdataError,
                        fundName: fetchedData.fundName.length === 0,
                        appraiser1: fetchedData.appraiser1 == undefined ||  fetchedData.appraiser1 == null || fetchedData.appraiser1.email == "",
                    });
                }}>
                    Save
                </Button>}
                {page === "view" && (fetchedData.status === "New" || fetchedData.status === "Revoked"  || fetchedData?.status?.includes("Rejected")) && <Button sx={{textTransform:"none",ml: 2}} variant="contained" size="medium" color="warning" onClick={() => window.location.assign('/global/global-equity/edit/'+appraisalId)} >
                    Edit
                </Button>
                }
                <Button sx={{textTransform:"none",ml: 2}} onClick={() => navigate('/global/dashboard')} variant="outlined" size="medium" color="error">
                    Close
                </Button>
                {page !== "view" && <Button sx={{textTransform:"none"}} disabled={disableControlesFlag}  variant="contained" size="medium" color="primary" className="text-right"  onClick={() => {
                    saveSubmitForm("Submit");
                    setPostFormdataError({
                        ...postFormdataError,
                        fundName: fetchedData.fundName.length === 0,
                        appraiser1: fetchedData.appraiser1 == undefined ||  fetchedData.appraiser1 == null || fetchedData.appraiser1.email == "",
                    });
                    isSubmitEvent.current = true;
                }}>
                    Submit
                </Button>}

                {(flagtaskcomponent && page === "view") && (
                <ApproveRejectComponent
                isError={setIsError}
                isSuccess={setIsSuccess}
                userContext={userContext}
                status={fetchedData.status}
                appraisalId={fetchedData.appraisalId}
                workflowId={fetchedData.workflowId}
              />
            )}
            </Box>
        </div >
    );
};
